/**
 * Firebase Storage helpers: upload, download URL, delete.
 */
import { firebase } from './config';

export const storage = firebase.storage();

/**
 * Upload a file to the given path and return the download URL.
 * @param {string} path - Storage path (e.g. "profiles/uid/avatar_123.jpg")
 * @param {File|Blob} file - File to upload
 * @returns {Promise<string>} download URL
 */
export function uploadFile(path, file) {
  const ref = storage.ref(path);
  return ref.put(file).then((snap) => snap.ref.getDownloadURL());
}

/**
 * Delete a file at the given path.
 * @param {string} path - Storage path
 * @returns {Promise<void>}
 */
export function deleteFile(path) {
  return storage.ref(path).delete();
}
